import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import MissionPage from "@/pages/MissionPage";
import ProgramsPage from "@/pages/ProgramsPage";
import ProgramDetailPage from "@/pages/ProgramDetailPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import PartnersPage from "@/pages/PartnersPage";
import DonatePage from "@/pages/DonatePage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import VolunteersPage from "@/pages/VolunteersPage";
import DynamicPage from "@/pages/DynamicPage";
import CookieConsent from "@/components/CookieConsent";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/programmes" element={<ProgramsPage />} />
          <Route path="/programmes/:slug" element={<ProgramDetailPage />} />
          <Route path="/projets" element={<ProjectsPage />} />
          <Route path="/projets/:slug" element={<ProjectDetailPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/partenaires" element={<PartnersPage />} />
          <Route path="/soutenir" element={<DonatePage />} />
          <Route path="/benevoles" element={<VolunteersPage />} />
          <Route path="/confidentialite" element={<DynamicPage />} />
          <Route path="/mentions-legales" element={<DynamicPage />} />
          <Route path="/page/:slug" element={<DynamicPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
